// Global Add-Customer modal for GCs / engineers / direct owners.

import { useState } from 'react';
import { useApp } from '@/context/AppContext';

export default function AddCustomerModal() {
  const { addCustomer, closeModal } = useApp();
  const [form, setForm] = useState({
    name:    '',
    contact: '',
    addr:    '',
    phone:   '',
    email:   '',
    notes:   '',
    status:  'active',
  });
  const set = (k, v) => setForm(prev => ({ ...prev, [k]: v }));

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name.trim()) return;
    addCustomer(form);
    closeModal();
  };

  return (
    <div className="modal" onClick={(e) => e.stopPropagation()}>
      <div className="modal-head">
        <span className="modal-title">Add Customer / GC</span>
        <button className="btn btn-ghost btn-sm" onClick={closeModal}>✕</button>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="modal-body">
          <div className="field">
            <label>Company Name *</label>
            <input value={form.name} onChange={e => set('name', e.target.value)} placeholder="e.g. Acme General Contractors" required />
          </div>
          <div className="form-row">
            <div className="field">
              <label>Contact Name</label>
              <input value={form.contact} onChange={e => set('contact', e.target.value)} placeholder="Primary contact" />
            </div>
            <div className="field">
              <label>Status</label>
              <select value={form.status} onChange={e => set('status', e.target.value)}>
                <option value="active">Active</option>
                <option value="at_risk">At Risk</option>
                <option value="inactive">Inactive</option>
              </select>
            </div>
          </div>
          <div className="field">
            <label>Address</label>
            <input value={form.addr} onChange={e => set('addr', e.target.value)} placeholder="1234 Commerce St, City, ST 12345" />
          </div>
          <div className="form-row">
            <div className="field">
              <label>Phone</label>
              <input value={form.phone} onChange={e => set('phone', e.target.value)} placeholder="(555) 555-5555" />
            </div>
            <div className="field">
              <label>Email</label>
              <input type="email" value={form.email} onChange={e => set('email', e.target.value)} placeholder="contact@gc.com" />
            </div>
          </div>
          <div className="field">
            <label>Notes</label>
            <textarea value={form.notes} onChange={e => set('notes', e.target.value)} placeholder="Payment terms, special requirements…" />
          </div>
        </div>
        <div className="modal-foot">
          <button type="button" className="btn btn-ghost" onClick={closeModal}>Cancel</button>
          <button type="submit" className="btn btn-primary">Add Customer</button>
        </div>
      </form>
    </div>
  );
}
